import { connect } from 'react-redux';
import React from 'react';
import { Tooltip } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import { Crop169Rounded, CropPortraitRounded, CropSquareRounded } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ASPECT_RATIO } from '../../CreatePageConstants';

const styles = (theme) => ({ 
    toggleButton: {
        padding: 12,
        borderRadius: '36px !important',
        border: 'none'
    }
});

class AspectRatioToggleButtonGroup extends React.Component {

    render() {
        const { 
            classes, aspectRatio
        } = this.props;

        return (
            <ToggleButtonGroup
                value={aspectRatio}
                exclusive
                onChange={(event, newValue) => {
                    if (newValue || newValue === 0)
                        this.onChange(newValue);
                }}
                aria-label='aspect ratio'
                size='medium'
            >
                
                <ToggleButton 
                    value={ASPECT_RATIO.LANDSCAPE}
                    className={classes.toggleButton}
                    aria-label='landscape'
                >
                    <Tooltip 
                        title='Landscape' 
                        arrow 
                        placement='bottom'
                    >
                        <Crop169Rounded />
                    </Tooltip>
                </ToggleButton>
                <ToggleButton 
                    value={ASPECT_RATIO.PORTRAIT}
                    className={classes.toggleButton}
                    aria-label='portrait'
                >
                    <Tooltip 
                        title='Portrait' 
                        arrow 
                        placement='bottom'
                    >
                        <CropPortraitRounded />
                    </Tooltip>
                </ToggleButton>
                <ToggleButton 
                    value={ASPECT_RATIO.SQUARE}
                    className={classes.toggleButton}
                    aria-label='square'
                >
                    <Tooltip 
                        title='Square' 
                        arrow 
                        placement='bottom'
                    >
                        <CropSquareRounded />
                    </Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
                
        );
    }

    onChange = (newValue) => {
        const { updateAspectRatio } = this.props;

        updateAspectRatio(newValue);
    }
}

const mapStateToProps = (state) => {
    const { aspectRatio } = state.createPreview.present.videoSettings; 

    return {
        aspectRatio
    }
}

const mapDispatchToProps = (dispatch) => {
    const updateAspectRatio = (aspectRatio) => dispatch(createActions.updateAspectRatio(aspectRatio));

    return {
        updateAspectRatio
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AspectRatioToggleButtonGroup, styles));